import React, { Component } from 'react';
import moment from 'moment';

import Icon from '../../../../../../components/Icon';
import PeriodSymbol from '../../../../../../components/PeriodSymbol';
import TableList from '../../../../../../components/TableList';
import LoadingIndicator from '../../../../../../components/LoadingIndicator';
import EmptyState from '../../../../../../components/EmptyState';
import AlertMessage from '../../../../../../components/AlertMessage';
import SidePanelListItem from '../../../../../../components/SidePanelListItem';

import './styles.css';

// utils

const periods = {
  MORNING: 0,
  AFTERNOON: 1,
  NIGHT: 2,
  DAWN: 3,
};

// component

class TrackingDetailsHistoryList extends Component {
  _getPeriodName = (periodCode) => {
    switch (periodCode) {
      case periods.MORNING:
        return 'MORNING';

      case periods.AFTERNOON:
        return 'AFTERNOON';

      case periods.NIGHT:
        return 'NIGHT';

      case periods.DAWN:
        return 'DAWN';

      default:
        return '';
    }
  }

  _renderDiffTd = (diff) => {
    if (diff > 0) {
      return (
        <TableList.Td className="TrackingDetailsHistoryList__td-danger">
          <Icon
            className="TrackingDetailsHistoryList__icon"
            name="arrow_upward"
          />
          {moment.duration(diff).humanize()}
        </TableList.Td>
      );
    }

    if (diff < 0) {
      return (
        <TableList.Td className="TrackingDetailsHistoryList__td-ok">
          <Icon
            className="TrackingDetailsHistoryList__icon"
            name="arrow_downward"
          />
          {moment.duration(diff).humanize()}
        </TableList.Td>
      );
    }

    return (
      <TableList.Td className="TrackingDetailsHistoryList__td-neutral">
        <Icon
          className="TrackingDetailsHistoryList__icon"
          name="done"
        />
        Sem alteração
      </TableList.Td>
    );
  }

  render() {
    const {
      className,
      data,
      isFetching,
      hasError,
    } = this.props;

    return (
      <div className={`TrackingDetailsHistoryList ${className || ''}`}>
        {/* ====================== */}
        {/*     ERROR STATE        */}
        {/* ====================== */}
        {
          hasError &&
          !isFetching &&
          <AlertMessage
            actionText="Tentar novamente"
            message="Ocorreu um erro"
            onRetry={this.props.onRetry}
            error
          />
        }


        {/* ====================== */}
        {/*     EMPTY STATE        */}
        {/* ====================== */}
        {
          data.length === 0 &&
          !isFetching &&
          !hasError &&
          <SidePanelListItem title="Histórico">
            <EmptyState message="Nenhum histórico de previsão para esta nota fiscal." />
          </SidePanelListItem>
        }

        {/* ====================== */}
        {/*     LOADING STATE      */}
        {/* ====================== */}
        {
          isFetching &&
          <LoadingIndicator theme="dark" text="Carregando..." />
        }

        {/* ====================== */}
        {/*     NORMAL STATE       */}
        {/* ====================== */}
        {
          !isFetching &&
          data.length > 0 &&
          !hasError &&
          <SidePanelListItem title="Histórico">
            <TableList>
              <thead>
                <tr>
                  <TableList.Th>Data</TableList.Th>
                  <TableList.Th>Previsão</TableList.Th>
                  <TableList.Th >Período</TableList.Th>
                  {/* <TableList.Th>Diferença (h)</TableList.Th> */}
                </tr>
              </thead>
              <tbody>
                {
                  data.map(item => (
                    <tr key={item.date}>
                      <TableList.Td>{moment(item.date).format('DD/MM/YYYY HH:mm')}</TableList.Td>
                      <TableList.Td>
                        <b>{moment(item.previewDate).format('DD/MM/YYYY')}</b>
                      </TableList.Td>
                      <TableList.Td >
                        <PeriodSymbol period={this._getPeriodName(item.period)} />
                      </TableList.Td>
                      {/* {this._renderDiffTd(item.diff)} */}
                    </tr>
                  ))
                }
              </tbody>
            </TableList>
          </SidePanelListItem>
        }
      </div>
    );
  }
}

export default TrackingDetailsHistoryList;
